var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-send-email-notification',{on:{"notification:sent":function($event){return _vm.$emit('notification:sent')}}})}
var staticRenderFns = []

export { render, staticRenderFns }